import React from "react";
import PropTypes from "prop-types";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";

// @material-ui/icons

import Face from "@material-ui/icons/Face";
import Email from "@material-ui/icons/Email";
// import LockOutline from "@material-ui/icons/LockOutline";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

import registerPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle";
import { Auth } from "aws-amplify";
import Amplify from "aws-amplify";
import aws_exports from "../../aws-exports";
import Snackbar from "components/Snackbar/Snackbar.jsx";

import CardHeader from "components/Card/CardHeader.jsx";
import cmplogo from "assets/img/cmp-logo.svg";
import CardFooter from "components/Card/CardFooter.jsx";
import API from "@aws-amplify/api";
Amplify.configure(aws_exports);

let apiName = process.env.REACT_APP_AMPLIFY_API;

class RegisterPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      arrayOfClientIds: [],
      cardAnimaton: "cardHidden",
      checked: [],
      email: "",
      password: "",
      firstname: "",
      lastname: "",
      clientId: "",
      clientIdState: "",
      registerFirstnameState: "",
      registerLastnameState: "",
      registerEmailState: "",
      registerPasswordState: "",
      errorMsg: "",
      tr: false,
      alertColor: "success",
    };
    this.handleToggle = this.handleToggle.bind(this);
    this.registerClick = this.registerClick.bind(this);
  }
  showNotification(place) {
    if (!this.state[place]) {
      var x = [];
      x[place] = true;
      this.setState(x);
      setTimeout(
        function() {
          x[place] = false;
          this.setState(x);
        }.bind(this),
        10000
      );
    }
  }

  verifyClientId(value) {
    if (this.state.arrayOfClientIds.indexOf(value) > -1) {
      return true;
    }
    return false;
  }
  verifyEmail(value) {
    var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRex.test(value)) {
      return true;
    }
    return false;
  }

  // function that verifies if a string has a given length or not
  verifyLength(value, length) {
    if (value.length >= length) {
      return true;
    }
    return false;
  }

  registerClick() {
    if (this.state.email === "") {
      this.setState({ registerEmailState: "error" });
    }
    if (this.state.password === "") {
      this.setState({ registerPasswordState: "error" });
    }
    if (this.state.firstname === "") {
      this.setState({ registerFirstnameState: "error" });
    }
    if (this.state.lastname === "") {
      this.setState({ registerLastnameState: "error" });
    }
    if (this.state.clientId === "") {
      this.setState({ clientIdState: "error" });
    }
  }
  handleChange(event, type) {
    this.setState({
      [event.target.id]: event.target.value,
    });
    switch (type) {
      case "email":
        if (this.verifyEmail(event.target.value)) {
          this.setState({ ["registerEmailState"]: "success" });
        } else {
          this.setState({ ["registerEmailState"]: "error" });
        }
        break;
      case "password":
        if (this.verifyLength(event.target.value, 8)) {
          this.setState({ ["registerPasswordState"]: "success" });
        } else {
          this.setState({ ["registerPasswordState"]: "error" });
        }
        break;
      case "firstname":
        if (this.verifyLength(event.target.value, 2)) {
          this.setState({ ["registerFirstnameState"]: "success" });
        } else {
          this.setState({ ["registerFirstnameState"]: "error" });
        }
        break;
      case "lastname":
        if (this.verifyLength(event.target.value, 2)) {
          this.setState({ ["registerLastnameState"]: "success" });
        } else {
          this.setState({ ["registerLastnameState"]: "error" });
        }
        break;
      case "clientId":
        if (this.verifyClientId(event.target.value)) {
          this.setState({ ["clientIdState"]: "success" });
        } else {
          this.setState({ ["clientIdState"]: "error" });
        }
        break;
    }
  }

  handleSubmit = async (event) => {
    event.preventDefault();
    this.registerClick();
    if (
      this.state.email !== "" &&
      this.state.password !== "" &&
      this.state.firstname !== "" &&
      this.state.lastname !== "" &&
      this.state.clientId !== "" &&
      this.state.clientIdState !== "error"
    ) {
      try {
        let username = this.state.email;
        let password = this.state.password;
        let email = this.state.email;
        let family_name = this.state.lastname;
        let given_name = this.state.firstname;
        let client_id = String(this.state.clientId);
        Auth.signUp({
          username,
          password,
          attributes: {
            email,
            family_name,
            given_name,
            "custom:client_id": client_id,
          },
        })
          .then((data) => {
            if (data["user"]["username"]) {
              this.setState({
                errorMsg:
                  "You are registered successfully!! Please confirm your registration",
              });
              this.setState({ alertColor: "success" });
              this.showNotification("tr");
              setTimeout(
                function() {
                  this.props.history.push("/confirm-signup");
                }.bind(this),
                6000
              );
            } else {
              this.setState({ errorMsg: "Registration Failed" });
              this.setState({ alertColor: "warning" });
              this.showNotification("tr");
            }
          })
          .catch((err) => {
            this.setState({ errorMsg: err["message"] });
            this.setState({ alertColor: "warning" });
            this.showNotification("tr");
          });
      } catch (e) {
        this.setState({ errorMsg: e["message"] });
        this.setState({ alertColor: "warning" });
        this.showNotification("tr");
      }
    }
  };

  handleToggle(value) {
    const { checked } = this.state;
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    this.setState({
      checked: newChecked,
    });
  }
  componentDidMount() {
    // we add a hidden class to the card and after 700 ms we delete it and the transition appears
    let path = "/clients";
    API.get(apiName, path)
      .then((response) => {
        let tempArrayOfClientIds = [];
        for (let eachclient in response) {
          if ("concepts" in response[eachclient]) {
            for (let eachconcept in response[eachclient]["concepts"]) {
              tempArrayOfClientIds.push(
                response[eachclient]["concepts"][eachconcept]["settings"][
                  "cmp"
                ]["clientId"]
              );
            }
          }
        }
        this.setState({
          arrayOfClientIds: tempArrayOfClientIds,
        });
      })
      .catch((error) => {
        console.log(error);
      });
    this.timeOutFunction = setTimeout(
      function() {
        this.setState({ cardAnimaton: "" });
      }.bind(this),
      700
    );
  }
  componentWillUnmount() {
    clearTimeout(this.timeOutFunction);
    this.timeOutFunction = null;
  }
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.fullPage}>
        <div className={classes.container}>
          <GridItem xs={12} sm={12} md={3}>
            <Snackbar
              place="tr"
              color={this.state.alertColor}
              message={this.state.errorMsg}
              open={this.state.tr}
              closeNotification={() => this.setState({ tr: false })}
              close
            />
          </GridItem>
          <GridContainer justify="center">
            <GridItem xs={12} sm={6} md={4}>
              <form className={classes.form} onSubmit={this.handleSubmit}>
                <Card login className={classes[this.state.cardAnimaton]}>
                  <CardHeader
                    className={`${classes.cardHeader} ${classes.textCenter}`}
                    color="primary"
                  >
                    <img src={cmplogo} alt="..." />
                    <h4 className={classes.cardTitle}>
                      Welcome to Customer Management Platform
                    </h4>
                  </CardHeader>
                  <CardBody>
                    <CustomInput
                      success={this.state.registerFirstnameState === "success"}
                      error={this.state.registerFirstnameState === "error"}
                      id="firstname"
                      labelText="FirstName *"
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses,
                      }}
                      inputProps={{
                        onChange: (event) =>
                          this.handleChange(event, "firstname"),
                        startAdornment: (
                          <InputAdornment
                            position="start"
                            className={classes.inputAdornment}
                          >
                            <Face className={classes.inputAdornmentIcon} />
                          </InputAdornment>
                        ),
                      }}
                    />

                    <CustomInput
                      success={this.state.registerLastnameState === "success"}
                      error={this.state.registerLastnameState === "error"}
                      id="lastname"
                      labelText="LastName *"
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses,
                      }}
                      inputProps={{
                        onChange: (event) =>
                          this.handleChange(event, "lastname"),
                        startAdornment: (
                          <InputAdornment
                            position="start"
                            className={classes.inputAdornment}
                          >
                            <Face className={classes.inputAdornmentIcon} />
                          </InputAdornment>
                        ),
                      }}
                    />

                    <CustomInput
                      success={this.state.registerEmailState === "success"}
                      error={this.state.registerEmailState === "error"}
                      labelText="Email *"
                      id="email"
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses,
                      }}
                      inputProps={{
                        type: "email",
                        onChange: (event) => this.handleChange(event, "email"),
                        startAdornment: (
                          <InputAdornment
                            position="start"
                            className={classes.inputAdornment}
                          >
                            <Email className={classes.inputAdornmentIcon} />
                          </InputAdornment>
                        ),
                      }}
                    />

                    <CustomInput
                      success={this.state.clientIdState === "success"}
                      error={this.state.clientIdState === "error"}
                      labelText="Client Id *"
                      id="clientId"
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses,
                      }}
                      inputProps={{
                        onChange: (event) =>
                          this.handleChange(event, "clientId"),
                        startAdornment: (
                          <InputAdornment
                            position="start"
                            className={classes.inputAdornment}
                          >
                            <Email className={classes.inputAdornmentIcon} />
                          </InputAdornment>
                        ),
                      }}
                    />

                    <CustomInput
                      success={this.state.registerPasswordState === "success"}
                      error={this.state.registerPasswordState === "error"}
                      id="password"
                      labelText="Password *"
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses,
                      }}
                      inputProps={{
                        type: "password",
                        onChange: (event) =>
                          this.handleChange(event, "password"),
                        startAdornment: (
                          <InputAdornment
                            position="start"
                            className={classes.inputAdornment}
                          >
                            <Icon className={classes.inputAdornmentIcon}>
                              lock_outline
                            </Icon>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </CardBody>
                  <CardFooter className={classes.justifyContentCenter}>
                    <Button
                      className="btn btncreate"
                      style={{ padding: "15px 25px" }}
                      color="secondary"
                      // size="lg"
                      type="submit"
                    >
                      Register
                    </Button>
                  </CardFooter>
                  <div className={classes.textCenter}>
                    <a href="/login">Login</a>
                  </div>
                </Card>
              </form>
            </GridItem>
          </GridContainer>
        </div>
      </div>
    );
  }
}

RegisterPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(registerPageStyle)(RegisterPage);



// WEBPACK FOOTER //
// ./src/views/Pages/RegisterPage.jsx